module.exports = __webpack_public_path__ + "static/media/uwm.61e0d8e1.png";